import { Swiper, Navigation, Autoplay, Scrollbar, Keyboard } from 'swiper';

Swiper.use([Autoplay, Navigation, Keyboard, Scrollbar]);

const navigation = (target) => {
  const swiperClass = {
    nextEl: `.${target}-swiper-controls__next`,
    prevEl: `.${target}-swiper-controls__prev`,
  };

  return swiperClass;
};

$(window).on('load', function () {
  swipers();
});

const swipers = () => {
  homeSwiper();
  gallerySwiper();
  dienstenRelatedSwiper();
  dienstenSwiper();
  imageSwiper();
  imageModalSwiper();
  floorplanSwiper();
  recentSwiper();
};

const homeSwiper = () => {
  return new Swiper('.home-swiper', {
    spaceBetween: 15,
    slidesPerView: 1,
    keyboard: true,
    loop: true,
    autoplay: {
      delay: 5000,
    },
  });
};

const gallerySwiper = () => {
  return new Swiper('.gallery-swiper', {
    spaceBetween: 30,
    slidesPerView: 2,
    keyboard: true,
    breakpoints: {
      1200: {
        slidesPerView: 2,
      },
      993: {
        slidesPerView: 2,
      },
      767: {
        slidesPerView: 1,
      },
      0: {
        slidesPerView: 1,
      },
    },
    navigation: navigation('gallery'),
    autoplay: {
      delay: 5000,
    },
  });
};

const dienstenRelatedSwiper = () => {
  return new Swiper('.diensten-related-swiper', {
    spaceBetween: 0,
    slidesPerView: 3,
    keyboard: true,
    breakpoints: {
      1200: {
        slidesPerView: 3,
      },
      993: {
        slidesPerView: 3,
      },
      767: {
        slidesPerView: 2,
      },
      0: {
        slidesPerView: 1,
      },
    },
    navigation: navigation('diensten-related'),
  });
};

const dienstenSwiper = () => {
  return new Swiper('.diensten-swiper', {
    spaceBetween: 30,
    slidesPerView: 3,
    keyboard: true,
    breakpoints: {
      1200: {
        slidesPerView: 3,
      },
      993: {
        slidesPerView: 3,
      },
      767: {
        slidesPerView: 2,
      },
      0: {
        slidesPerView: 1,
      },
    },
    navigation: navigation('diensten'),
    autoplay: {
      delay: 5000,
    },
  });
};

const imageSwiper = () => {
  return new Swiper('.image-swiper', {
    spaceBetween: 0,
    slidesPerView: 1,
    keyboard: true,
    loop: true,
    autoplay: {
      delay: 5000,
    },
    navigation: navigation('image-modal'),
  });
};

const imageModalSwiper = () => {
  return new Swiper('.image-modal-swiper', {
    spaceBetween: 0,
    slidesPerView: 1,
    keyboard: true,
    loop: true,
    autoplay: {
      delay: 5000,
    },
    navigation: navigation('image-modal'),
  });
};

const floorplanSwiper = () => {
  return new Swiper('.floorplan-swiper', {
    spaceBetween: 0,
    slidesPerView: 1,
    keyboard: true,
    loop: true,
    autoplay: {
      delay: 5000,
    },
    navigation: navigation('floorplan'),
  });
};

const recentSwiper = () => {
  return new Swiper('.recent-swiper', {
    spaceBetween: 30,
    slidesPerView: 3,
    keyboard: true,
    breakpoints: {
      1200: {
        slidesPerView: 3,
      },
      993: {
        slidesPerView: 3,
      },
      767: {
        slidesPerView: 2,
      },
      0: {
        slidesPerView: 1,
        spaceBetween: 15,
      },
    },
    navigation: navigation('recent'),
  });
};
